import reducer from "./reducer";
export { default as AnnotationsPage } from "./components/index";
export { default as annotationsPageReducerName } from "./constants";
export default reducer;
